import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enUI from "./locales/en/ui.json";
import bgUI from "./locales/bg/ui.json";
import elUI from "./locales/el/ui.json";
import esUI from "./locales/es/ui.json";
import frUI from "./locales/fr/ui.json";
import ptUI from "./locales/pt/ui.json";
import plUI from "./locales/pl/ui.json";
import deUI from "./locales/de/ui.json";
import trUI from "./locales/tr/ui.json";
import bgFishingIntelligence from "./locales/fishingIntelligence/bg.json";
import deFishingIntelligence from "./locales/fishingIntelligence/de.json";
import elFishingIntelligence from "./locales/fishingIntelligence/el.json";
import enFishingIntelligence from "./locales/fishingIntelligence/en.json";
import esFishingIntelligence from "./locales/fishingIntelligence/es.json";
import frFishingIntelligence from "./locales/fishingIntelligence/fr.json";
import plFishingIntelligence from "./locales/fishingIntelligence/pl.json";
import ptFishingIntelligence from "./locales/fishingIntelligence/pt.json";
import trFishingIntelligence from "./locales/fishingIntelligence/tr.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    load: "languageOnly",
    fallbackLng: "en",
    supportedLngs: ["en", "bg", "el", "es", "fr", "pt", "pl", "de", "tr"],
    resources: {
      en: { ui: { ...enUI, ...enFishingIntelligence } },
      bg: { ui: { ...bgUI, ...bgFishingIntelligence } },
      el: { ui: { ...elUI, ...elFishingIntelligence } },
      es: { ui: { ...esUI, ...esFishingIntelligence } },
      fr: { ui: { ...frUI, ...frFishingIntelligence } },
      pt: { ui: { ...ptUI, ...ptFishingIntelligence } },
      pl: { ui: { ...plUI, ...plFishingIntelligence } },
      de: { ui: { ...deUI, ...deFishingIntelligence } },
      tr: { ui: { ...trUI, ...trFishingIntelligence } },
    },
    ns: ["ui"],
    defaultNS: "ui",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
